var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvanaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 720",
    style: {
      enableBackground: "new 0 0 1280 720"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#BB2626;}\r\n\t.st2{display:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "400.02,454.98 448.27,496.82 449.7,496.82 452.66,496.82 455.63,496.82 457.05,496.82 505.3,454.98  505.3,413.14 484.39,413.14 484.39,444.52 453,472.42 452.32,472.42 420.94,444.52 420.94,413.14 400.02,413.14  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.03,437.55c0,49.63-2.89,58.1,27.97,59.27h41.76v-24.41l-39.29,0.03c-7.1,0.01-9.1-2.21-9.57-8.04 l0.04-16.41c0-6.31,0.7-10.47,9.93-10.47l59.8,0.01v59.27h20.92v-83.69l-88.74-0.02C537.01,413.11,529.03,422.44,529.03,437.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800.75,437.55c0,49.63-2.89,58.1,27.97,59.27h41.77v-24.41l-39.29,0.03c-7.09,0.01-9.09-2.21-9.56-8.04 l0.04-16.41c0-6.31,0.7-10.47,9.92-10.47l59.81,0.01v59.27h20.92v-83.69l-88.74-0.02C808.73,413.11,800.75,422.44,800.75,437.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.07,437.55c0,49.63-2.89,58.1,27.97,59.27h41.77v-24.41l-39.29,0.03c-7.1,0.01-9.1-2.21-9.57-8.04 l0.04-16.41c0-6.31,0.7-10.47,9.93-10.47l59.81,0.01v59.27h20.91v-83.69l-88.74-0.02C279.05,413.11,271.07,422.44,271.07,437.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M664.75,437.55l-0.04,59.27l21.06,0.05l-0.1-48.87c0-6.31,0.7-10.47,9.93-10.47l59.8,0.01v59.27h20.92v-83.69 l-88.74-0.02C672.73,413.11,664.75,422.44,664.75,437.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M983.47,421.06c-2.93,6.73-9.05,12.79-11.85,11.91c-9.53-2.98-3.88-16.93,2.72-33.9 c1.58-4.07,7.62-24.31,7.82-21.09C983.03,392.31,984.34,395.58,983.47,421.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M950.08,329.75c-16.31-8.68-60.67-24.11-60.67-43.39c0-11.75,10.85-27.78,35.02-28.01 c24.17-0.22,51.28,8.81,63.25,24.62c11.98,15.82,21.64,32.46,21.31,67.61c-0.11,12.12-8.3,96.31-23.96,71.95 c1.25-24.32,0.75-25.84-1.57-50.94c-0.3-3.22-0.31-15.65-0.31-15.65c11.95-5.99,10.05-21.37,4.3-30.73 c-7.23-11.75-16.18-19.39-18.45-20.97c-2.26-1.58-6.38-3.78-6.63-2.54c-0.69,3.34,13.18,14.25,19.67,22.14 c8.42,10.23,7.01,29.13-0.24,28.02C968.12,349.77,964.81,337.59,950.08,329.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M875.33,235.13c2.93-6.73,9.05-12.79,11.85-11.91c9.53,2.98,3.88,16.93-2.72,33.9 c-1.58,4.07-7.62,24.31-7.82,21.09C875.79,263.87,874.47,260.6,875.33,235.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M908.72,326.44c16.32,8.67,60.67,24.11,60.67,43.39c0,11.74-10.84,27.78-35.01,28.01 c-24.17,0.23-51.29-8.81-63.26-24.62c-11.97-15.82-21.63-32.45-21.31-67.61c0.11-12.12,8.3-96.31,23.96-71.95 c-1.25,24.32-0.76,25.84,1.57,50.94c0.3,3.22,0.3,15.65,0.3,15.65c-11.94,5.99-10.05,21.38-4.29,30.73 c7.23,11.75,16.18,19.39,18.44,20.97c2.26,1.58,6.37,3.78,6.64,2.54c0.69-3.34-13.19-14.26-19.67-22.14 c-8.41-10.23-7.01-29.13,0.24-28.02C890.69,306.42,893.99,318.61,908.72,326.44"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvanaLogo);
export default __webpack_public_path__ + "static/media/Avana-logo.6e14f7e16cd316806cd528dc3f2115f7.svg";
export { ForwardRef as ReactComponent };